import React from "react";
import { Grid, Hidden } from "@material-ui/core";
import "./index.css";
import saiba_mais from "../../assets/icones/saiba_mais.gif";

function MainSection() {
  return (
    <div className="background" id="home">
      <Grid container justify="center">
        <Grid item xs={10}>
          <h1 className="title">Nossa Empresa</h1>
        </Grid>
        <Grid item xs={10}>
          <p className="subtitle">
            Tem como missão, oferecer com excelência consultoria, assessoria e
            suporte técnico no que compete a Regularização Fundiária; Elaboração
            de Projetos Ambientais para Organizações e Prefeituras; e Oferta de
            Soluções para Planejamento Territorial e Gestão Pública em Geral com
            uso de Aplicações (Softwares) para maximizar a eficácia dos
            processos.
          </p>

          <p className="subtitle">
            Produtos ofertados: REURB, TARS, IGP e Planejamento Territorial.
          </p>
          <p className="subtitle">
            Nosso propósito é contribuir com o positivo desenvolvimento do
            Brasil, oferecendo novas possibilidades de se pensar e fazer
            Planejamento Territorial, sobretudo Urbano, incluindo conceitos e
            técnicas modernas, considerando uso de tecnologias e olhares multi e
            interdisciplinares.
          </p>
        </Grid>
        <Grid item xs={12} style={{ marginBottom: 600 }}>
          <Grid container justify="center">
            <Grid item xs={3} sm={2} md={1}>
              <a
                href="#reurb"
                style={{
                  textDecoration: "none",
                }}
              >
                <img
                  alt="Botão saiba mais"
                  className="btnKnowMore"
                  src={saiba_mais}
                />
              </a>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default MainSection;
